import {GROUPES} from 'redux/actionTypes';
import Api from 'services/Api';

import {Dominoes} from 'redux/actions';

let currentAjax = {};

export const activeMoveGroup = (group) => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.ACTIVE_MOVE,
			payload: {
				group
			}
		});
	}
}

export const setCurrentGroup = (group) => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.SET_CURRENT,
			payload: {
				group
			}
		});
	}
}

export const resetEstimate = () => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.RESET_ESTIMATE
		});
	}
}

export const setGroupes = (groupes) => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.SET_GROUPES,
			payload: {
				groupes
			}
		});
	}
}

export const getDataGroupToBuild = (idSession, idGroup) => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.LOADING,
			payload: {
				fetching: true
			}
		});

		Api.get(
			{},
			'/domino-group/tool-build/' + idSession + '/' + idGroup,
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: GROUPES.SET_CURRENT,
					payload: {
						group: data
					}
				});
				dispatch({
					type: GROUPES.LOADING,
					payload: {
						fetching: false
					}
				});
			}
		);
	};
}

export const estimateGroup = (params, callback = false) => {
	return (dispatch) => {

		params.estimate = true;
		dispatch({
			type: GROUPES.LOADING_ESTIMATE,
			payload: {
				fetching: true
			}
		});

		if (
			typeof currentAjax['estimateGroup'] !== 'undefined' &&
			typeof currentAjax['estimateGroup'].cancel === 'function'
		) {
			currentAjax['estimateGroup'].cancel();
		}
		currentAjax['estimateGroup'] = Api.post(
			params,
			'domino-group/add',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				if (typeof callback === 'function') {
					callback(data);
				}

				dispatch({
					type: GROUPES.SET_ESTIMATE,
					payload: {
						estimate: data
					}
				});
			}
		);
	};
}

export const addGroup = (params, callback = false) => {
	return (dispatch) => {

		dispatch({
			type: GROUPES.LOADING,
			payload: {
				fetching: true
			}
		});

		if (
			typeof currentAjax['addGroup'] !== 'undefined' &&
			typeof currentAjax['addGroup'].cancel === 'function'
		) {
			currentAjax['addGroup'].cancel();
		}
		currentAjax['addGroup'] = Api.post(
			params,
			'domino-group/add',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				if (typeof callback === 'function') {
					callback(data);
				}

				dispatch({
					type: GROUPES.LOADING,
					payload: {
						fetching: false
					}
				});
				dispatch(setGroupes(data.groups));
				return dispatch(Dominoes.set(data.dominoes));
			}
		);
	};
}


export const deleteGroup = (params, callback) => {
	return (dispatch) => {
		dispatch({
			type: GROUPES.LOADING,
			payload: {
				fetching: true
			}
		});
		Api.post(
			params,
			'domino-group/delete',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: GROUPES.LOADING,
					payload: {
						fetching: false
					}
				});
				dispatch(setGroupes(data.groups));
				dispatch(Dominoes.set(data.dominoes));

				if (typeof callback === 'function') {
					callback();
				}

				return;
			}
		);
	};
}

export const updateGroup = (params, callback) => {
	return (dispatch) => {
		Api.post(
			params,
			'domino-group/update',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				if (typeof callback === 'function') {
					callback();
				}
				dispatch(setGroupes(data.groups));
				return dispatch(Dominoes.set(data.dominoes));
			}
		);
	};
};

export const updateBuildDetailWithoutRedux = (id, detail) => {
	Api.put(
		{
			buildDetail: detail
		},
		'domino_group_details/' + id,
		(error, data) => {
			if (error) {
				//TODO ERROR
			}

		}
	);
};
